import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Button, Popconfirm, Space, Typography } from 'antd'
import { DeleteOutlined, FileOutlined } from '@ant-design/icons'

const THUMBNAIL_SIZE = 44

const AttachmentLink = ({ attachment }) => {
  if (attachment.thumbnailUrl) {
    return (
      <a href={attachment.url} rel='noopener noreferrer' target='_blank' title={attachment.filename}>
        <img
          alt={attachment.filename}
          height={THUMBNAIL_SIZE}
          src={attachment.thumbnailUrl}
          style={{ objectFit: 'cover' }}
          width={THUMBNAIL_SIZE}
        />
      </a>
    )
  }

  return (
    <a href={attachment.url} rel='noopener noreferrer' target='_blank'>
      <FileOutlined /> {attachment.filename}
    </a>
  )
}

AttachmentLink.propTypes = {
  attachment: PropTypes.object.isRequired
}

const Attachments = ({ attachments, deletingId, onDelete }) => {
  const { t } = useTranslation('loanAgreements')

  if (!attachments.length) return <Typography.Text type='secondary'>-</Typography.Text>

  return (
    <Space size={[8, 8]} wrap>
      {attachments.map(attachment => (
        <Space key={attachment.id} size={2}>
          <AttachmentLink attachment={attachment} />
          {onDelete && (
            <Popconfirm
              cancelText={t('cancel')}
              okText={t('delete')}
              onConfirm={() => onDelete(attachment)}
              title={t('deleteAttachmentConfirm')}
            >
              <Button
                danger
                icon={<DeleteOutlined />}
                loading={deletingId === attachment.id}
                size='small'
                type='text'
              />
            </Popconfirm>
          )}
        </Space>
      ))}
    </Space>
  )
}

Attachments.propTypes = {
  attachments: PropTypes.array,
  deletingId: PropTypes.string,
  onDelete: PropTypes.func
}

Attachments.defaultProps = {
  attachments: [],
  deletingId: null,
  onDelete: null
}

export default Attachments
